import { createContext, useContext, useState } from 'react';

const FilterContext = createContext({
  isFilterOpen: false,
  toggleFilter: () => {},
  setIsFilterOpen: () => {},
});

export const FilterProvider = ({ children }) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const toggleFilter = () => setIsFilterOpen(prev => !prev);

  return (
    <FilterContext.Provider value={{ isFilterOpen, toggleFilter, setIsFilterOpen }}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilterContext = () => useContext(FilterContext);
